import { withSearch } from '@elastic/react-search-ui'
import type { SearchContextState } from '@elastic/react-search-ui/lib/cjs/withSearch'
import { useIntl } from 'react-intl'

import { Collapse, useTheme } from '@mui/material'

import ArrowDownSVG from 'app/assets/icons/arrow-down.svg'
import ArrowUpSVG from 'app/assets/icons/arrow-up.svg'
import LightningIcon from 'app/assets/icons/lightning.svg'
import Box from 'app/components/base/Box'
import IconButton from 'app/components/base/IconButton'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import AttributeFilters from 'app/features/SearchFeature/components/AttributeFilters'
import useSearchAttributeFilters from 'app/features/SearchFeature/hooks/useSearchAttributeFilters'
import useBoolean from 'app/hooks/useBoolean'
import ClearAllFilterButton from 'app/libs/elastic/filters/ClearAllFilterButton'

const selector = ({ filters, removeFilter }: SearchContextState) => ({
  filters,
  removeFilter
})

const FitmentCollapseFilter: RFC<SearchContextState> = ({
  filters,
  removeFilter
}) => {
  const [isCollapseOpen, collapseHandlers] = useBoolean()
  const { palette } = useTheme()
  const { formatMessage } = useIntl()

  const { isAttributionsPresent, attributions } = useSearchAttributeFilters({
    filters,
    removeFilter
  })

  if (!isAttributionsPresent) return null

  return (
    <Stack
      className="fitment-filters"
      direction="column"
      spacing={1.25}
      sx={{ width: '100%' }}
    >
      <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
        <Stack
          direction="row"
          spacing={1}
          sx={{ alignItems: 'center', cursor: 'pointer' }}
          onClick={() => collapseHandlers.toggle()}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              background: `linear-gradient(90deg, ${palette.secondary.light} 0%, ${palette.secondary.main} 100%)`,
              borderRadius: '50%',

              'svg path': { fill: 'white' }
            }}
          >
            <LightningIcon />
          </Box>

          <Text variant="body2" component="p" sx={{ fontWeight: 500 }}>
            {formatMessage({ defaultMessage: 'Specify Fitment Details' })}
          </Text>

          <IconButton
            size="small"
            disableRipple
            aria-label={isCollapseOpen ? 'Collapse section' : 'Expand section'}
            sx={{ px: 0 }}
          >
            {isCollapseOpen ? <ArrowUpSVG /> : <ArrowDownSVG />}
          </IconButton>
        </Stack>

        <ClearAllFilterButton />
      </Stack>

      <Collapse
        timeout={100}
        mountOnEnter
        in={isCollapseOpen}
        sx={{
          '.MuiFormControl-root.MuiTextField-root': { width: { lg: 175 } }
        }}
      >
        <AttributeFilters
          attributions={attributions}
          stackProps={{ direction: 'row', sx: { flexWrap: 'wrap', gap: 1.25 } }}
        />
      </Collapse>
    </Stack>
  )
}

export default withSearch(selector)(FitmentCollapseFilter)
